export default __webpack_public_path__ + "static/media/colorSplotchPlatinum.a74aa695.svg";